module.exports = __webpack_public_path__ + "static/media/userIcon.98202e9f.svg";